import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o empréstimo para o carro com a placa <b>${this.currentEntity.plate}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/parking/resources/computed.js